import "./veriColourPicker.scss";
import { IColour } from "@services/colour.service";
import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
    selector: 'veri-colour-picker',
    template: require('./veriColourPicker.html')
})
export class VeriColourPickerComponent {
    @Input() selectedColour: IColour;
    @Output() colourSelected: EventEmitter<IColour> = new EventEmitter<IColour>();

    @Input() availableColours: IColour[];

    constructor() { }

    selectColour(colour: IColour) {
        if (!colour || this.selectedColour && this.selectedColour.solidColour === colour.solidColour) {
            this.selectedColour = null;
        } else {
            this.selectedColour = colour;
        }

        this.colourSelected.emit(this.selectedColour);
    }
}
//import * as angular from "angular";

//import "./veriColourPicker.scss";
//import { IColour } from "@services/colour.service";

//interface IColourPickerBindings {
//    avliableColours: IColour[];
//    selectedColour: IColour;

//    colourSelected: (args: { colour: IColour }) => void;
//}

//class ColourPickerComponentController implements angular.IComponentController, IColourPickerBindings {

//    avliableColours: IColour[];
//    selectedColour: IColour;

//    colourSelected: (args: { colour: IColour }) => void;
    
//    selectColour(colour: IColour) {
//        if (!colour || this.selectedColour && this.selectedColour.solidColour === colour.solidColour) {
//            this.selectedColour = null;
//        } else {
//            this.selectedColour = colour;
//        }

//        if (this.colourSelected) {
//            this.colourSelected({ colour: this.selectedColour });
//        }
//    }
//}

//export class ColourPickerComponent implements angular.IComponentOptions {
//    bindings: any;
//    controller: any;
//    template: string;

//    constructor() {
//        this.bindings = {
//            avliableColours: "<",
//            selectedColour: "<",

//            colourSelected: "&"
//        };

//        this.controller = ColourPickerComponentController;
//        this.template = require("./veriColourPicker.html");

//    }
//}
